import { ConfirmationModal } from "../../../shared/components/common";
import { ReactComponent as Delete } from "../../../assets/icons/delete-fill.svg";

const DeletePaymentMethodModal = ({
  open,
  onClose,
  onConfirm,
  paymentMethod,
  isSubmitting = false,
}) => {
  const handleConfirm = async () => {
    if (paymentMethod) {
      await onConfirm(paymentMethod);
    }
  };

  const maskedNumber = paymentMethod?.last4
    ? `•••• •••• •••• ${paymentMethod.last4}`
    : "this payment method";

  return (
    <ConfirmationModal
      show={open}
      onCancel={onClose}
      onConfirm={handleConfirm}
      title="Delete Payment Method"
      messages={[
        `Are you sure you want to delete ${maskedNumber}?`,
        "This action cannot be undone.",
      ]}
      confirmText={isSubmitting ? "Deleting..." : "Delete"}
      cancelText="Cancel"
      confirmColor="error"
      cancelColor="primary"
      isSubmitting={isSubmitting}
      IconComponent={Delete}
      iconClassName="w-20 h-24"
    />
  );
};

export default DeletePaymentMethodModal;
